import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { NavbarAlert } from "examples/Alert";
import Header from "./header";

const Profile = () => {
  return (
    <>
      <DashboardNavbar />
      <NavbarAlert isProfile={true} />
      <DashboardLayout>
        <MDBox
          sx={{
            mt: 10,
            "@media (max-width:767px)": { mt: 10 },
          }}
        >
          <Header />
        </MDBox>
      </DashboardLayout>
    </>
  );
};

export default Profile;
